import { Applicant } from '../Applicant.types';
import { ApplicantInfoCard, ApplicantInfoRow } from './ApplicantInfoCard';

interface FuelInformationProps {
    applicant: Applicant;
}

export const FuelInformation = ({ applicant }: FuelInformationProps) => {
    const fuelProduct = applicant.tcsFuelCardProduct;

    if (!fuelProduct) {
        return null;
    }

    return (
        <ApplicantInfoCard title="Fuel Information">
            <ApplicantInfoRow
                label="Name on Card"
                value={fuelProduct.nameOnCard}
                data-testid="fuel-name-on-card"
            />
            <ApplicantInfoRow
                label="Fuel Cards Needed"
                value={fuelProduct.fuelCardsNeeded?.toString()}
                data-testid="fuel-cards-needed"
            />
        </ApplicantInfoCard>
    );
};
